import React, { Component } from "react";
import beautify from "js-beautify";
import pugBeautify from "pug-beautify";
import AceEditor from "react-ace";
import "brace/mode/html";
import "brace/mode/xml";
import "brace/mode/jade";
import "brace/theme/tomorrow_night"; // Dark theme
import "brace/theme/eclipse"; // Light theme
import { HTMLCode as defaultHTMLCode, JADECode as defaultJADECode } from "./template";
import "./App.css";
import "./fonts.css";

class App extends Component {
  state = {
    HTMLCode: '',
    JADECode: '',
    tabSize: 2,
    useSoftTabs: true,
  };

  constructor() {
    super();
    this.Html2Jade = window.Html2Jade;
    this.pug = window.pug;
  }

  componentDidMount() {
    this.loadTemplate();
    this.loadSettings();
  }

  loadTemplate = () => {
    this.setState({
      HTMLCode: defaultHTMLCode,
      JADECode: defaultJADECode,
    }, this.applySettingsToCode);
  }

  loadSettings = () => {
    const useSoftTabs = localStorage.getItem("useSoftTabs");
    const tabSize = localStorage.getItem("tabSize");

    if (useSoftTabs !== null) {
      this.setState({ useSoftTabs: useSoftTabs === "true" });
    }

    if (tabSize !== null) {
      this.setState({ tabSize: parseInt(tabSize, 10) });
    }
  };

  saveSettings = () => {
    localStorage.setItem("useSoftTabs", this.state.useSoftTabs);
    localStorage.setItem("tabSize", this.state.tabSize);
  };

  applySettingsToCode = () => {
    const { HTMLCode, JADECode, tabSize, useSoftTabs } = this.state;

    const formattedHTMLCode = beautify.html(HTMLCode, {
      indent_size: tabSize,
      indent_with_tabs: !useSoftTabs,
    });

    let formattedJADECode = pugBeautify(JADECode, {
      fill_tab: !useSoftTabs,
      tab_size: tabSize,
    });

    this.setState({
      HTMLCode: formattedHTMLCode,
      JADECode: formattedJADECode,
    });
  };

  onHTMLChange = (newCode) => {
    this.setState({ HTMLCode: newCode });
    this.updateJADE();
  };

  onIndentTypeChange = (event) => {
    const useSoftTabs = event.target.value === "yes";
    this.setState({ useSoftTabs }, () => {
      this.saveSettings();
      this.applySettingsToCode();
    });
  };

  onJADEChange = (newCode) => {
    this.setState({ JADECode: newCode });
    this.updateHTML();
  };

  updateHTML = () => {
    try {
      const HTMLCode = this.pug.render(this.state.JADECode, { pretty: true });

      let sanitizeHTMLCode = HTMLCode.replace(/^\n/, "");
      sanitizeHTMLCode = beautify.html(sanitizeHTMLCode, {
        indent_size: this.state.tabSize,
        indent_with_tabs: !this.state.useSoftTabs,
      });
      this.setState({ HTMLCode: sanitizeHTMLCode });
    } catch (error) {
      // Handle the error
    }
  };

  onTabSizeChange = (event) => {
    this.setState({ tabSize: parseInt(event.target.value, 10) }, () => {
      this.saveSettings();
      this.applySettingsToCode();
    });
  };

  findHTMLOrBodyTag = (html) => html.search(/<\/html>|<\/body>/) > -1;

  updateJADE = () => {
    const { HTMLCode } = this.state;
    const isBodyless = !this.findHTMLOrBodyTag(HTMLCode);
    const options = {
      bodyless: isBodyless,
      donotencode: true,
    };

    if (HTMLCode === "") {
      this.setState({ JADECode: "" });
      return;
    }

    const html = HTMLCode.replace(/template/g, "template_");
    this.Html2Jade.convertHtml(html, options, (err, jade) => {
      if (err) {
        return;
      }
      let sanitizeJade = jade
        .replace(/\|\s+$/gm, "")
        .replace(/^(?:[\t ]*(?:\r?\n|\r))+/gm, "");
      if (isBodyless) {
        sanitizeJade = sanitizeJade.replace("head\n", "");
      }
      sanitizeJade = sanitizeJade.replace(/template_/g, "template");
      sanitizeJade = pugBeautify(sanitizeJade, {
        fill_tab: !this.state.useSoftTabs,
        tab_size: this.state.tabSize,
      });
      this.setState({ JADECode: sanitizeJade });
    });
  };

  render() {
    const { tabSize, useSoftTabs } = this.state;
    const options = {
      showLineNumbers: false,
      showGutter: false,
      displayIndentGuides: false,
      printMargin: false,
      useSoftTabs,
      tabSize,
    };

    return (
      <React.Fragment>
        <header className="row p-1">
          <div className="col-12 text-left">
            <div className="row align-items-end">
            <div className="col-12 col-xs-12 col-lg-12 col-xl">
  <h1 className="logo">HTML to JADE/PUG
  <span className="small pl-3 nowrap">realtime converter</span></h1>
</div>



              <div className="col-sm text-center setting">
                <label>
                  <input
                    type="radio"
                    name="useSoftTabs"
                    value="yes"
                    checked={this.state.useSoftTabs}
                    onChange={this.onIndentTypeChange}
                  />
                  spaces
                </label>
                <label>
                  <input
                    type="radio"
                    name="useSoftTabs"
                    value="no"
                    checked={!this.state.useSoftTabs}
                    onChange={this.onIndentTypeChange}
                  />
                  tabs
                </label>
                <select
                  name="tabSize"
                  value={tabSize}
                  onChange={this.onTabSizeChange}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </select>
                width of indent
              </div>
              <div className="col-1">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  id="installButton"
                  style={{ display: "none" }}
                  onClick={this.props.onInstallButtonClick}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="#fff"
                      d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
                    />
                  </svg>
                </button>
              </div>
              <div className="col col-lg-2">
                <div className="text-right">
                <div id="donate-button-container">
                <a
                  className="nav-link"
                  href="https://buymeacoffee.com/dvamv"
                  role="button"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                    loading="lazy"
                    alt="jpgtopngconverter Buy Me A Coffee"
                    className="donate-button-img"
                  />
                </a>
              </div>
                  <a
                    href="https://github.com/dylankbuckley/html2pug/issues/new"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Report an issue
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>
        <section>
          <div className="row">
            <div className="col-12 col-md-6 editor editor-html">
              <AceEditor
                mode="html"
                theme={
                  this.props.theme === "dark" ? "tomorrow_night" : "eclipse"
                } // Use the dynamic theme
                name="ace-html"
                fontSize={16}
                value={this.state.HTMLCode}
                onChange={this.onHTMLChange}
                setOptions={options}
                editorProps={{ $blockScrolling: true }}
              />
            </div>
            <div className="col-12 col-md-6 editor editor-jade">
              <AceEditor
                mode="jade"
                theme={
                  this.props.theme === "dark" ? "tomorrow_night" : "eclipse"
                } // Use the dynamic theme
                name="ace-jade"
                fontSize={16}
                value={this.state.JADECode}
                onChange={this.onJADEChange}
                setOptions={options}
                editorProps={{ $blockScrolling: true }}
              />
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js